import React from "react";
import { Field } from "redux-form";
import { Box } from "rebass";
import { Responsive, required } from "admin-on-rest"; //GET_LIST ,
import {
  Table,
  TableBody,
  TableHeader,
  TableFooter,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import { TextField } from "redux-form-material-ui";
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import FlatButton from "material-ui/FlatButton";
import ContentAdd from "material-ui/svg-icons/content/add-circle";
import ActionDelete from "material-ui/svg-icons/action/highlight-off";

import NavigationChevronRight from "material-ui/svg-icons/navigation/chevron-right";
import {
  renderMultiTextField,
  renderDateField,
  renderTimeField,
  renderTextFieldView,
  renderSelectField
} from "../OrderFormField";
import {
  DivStatus,
  HeaderForm,
  HeaderDateTime,
  HeaderTitle,
  DivCustomerInfo,
  DivCustomerInfoBox,
  DivCustomerInfoBox1,
  DivActions
} from "../styled";
import LoaderButton from "../../components/button/LoaderButton";
import { styles } from "../styles";
// import { renderTitle , renderField } from './edit/EditOrderField'

export const isRequired = validate => {
  if (validate === required) return true;
  if (Array.isArray(validate)) {
    return validate.includes(required);
  }
  return false;
};

export const renderTitle = title => (
  <HeaderTitle>
    <h3>{title} </h3>{" "}
    <NavigationChevronRight
      style={styles.iconHeader}
      color={styles.headerTitle.color}
    />
  </HeaderTitle>
);
export const renderField = ({ input, ...rest }) => (
  <Field
    {...rest}
    {...input.props}
    name={input.props.source}
    component={input.type}
    isRequired={isRequired(input.props.validate)}
  />
);

export const renderCustomer = (
  children,
  record,
  permissions,
  reSendEmail,
  isResend,
  marketer
) => {
  const isCompleted =
    record && record.status && record.status === "completed" ? true : false;
  return (
    <div>
      <HeaderForm>
        <div />
        <HeaderDateTime>
          {permissions === "Admin" && (
            <Field
              label="Issue Date"
              name="issued_at"
              component={renderDateField}
            />
          )}
          {permissions !== "Admin" && (
            <Field
              label="Issue Date"
              name="issued_at"
              component={renderDateField}
              disabled="true"
            />
          )}
          &nbsp;
          {permissions === "Admin" && (
            <Field label="time" name="issued_at" component={renderTimeField} />
          )}
          {permissions !== "Admin" && (
            <Field
              label="time"
              name="issued_at"
              component={renderTimeField}
              disabled="true"
            />
          )}
        </HeaderDateTime>
      </HeaderForm>
      <DivStatus>
        {marketer &&
          marketer !== "" && (
            <Box pr={[2]} pb={[1]}>
              <TextField
                disabled={true}
                value={marketer}
                floatingLabelText="Marketer"
              />
            </Box>
          )}
        <Field label="Status" name="status" component={renderSelectField}>
          <MenuItem value="pending payment" primaryText="Pending Payment" />
          <MenuItem value="paid" primaryText="Paid" />
          <MenuItem value="delivered" primaryText="Delivered" />
          {/* <MenuItem value="invoiced" primaryText="Invoice" />
          <MenuItem value="expired" primaryText="Expired" /> */}
          <MenuItem value="preparing" primaryText="Preparing" />
          <MenuItem value="out for delivery" primaryText="Out for Delivery" />
          <MenuItem value="rejected" primaryText="Rejected" />
          <MenuItem value="cancelled" primaryText="Cancelled" />
          <MenuItem value="completed" primaryText="Completed" />
        </Field>
      </DivStatus>
      {isCompleted && (
        <DivActions>
          <LoaderButton
            label="Re-send Email"
            onClick={reSendEmail}
            requesting={isResend}
          />
        </DivActions>
      )}
      {renderTitle("Customer")}
      <Divider />
      <DivCustomerInfo>
        <DivCustomerInfoBox>
          <Field
            name="customer_info.first_name"
            component={TextField}
            floatingLabelText="First Name"
            fullWidth={true}
          />
          <Field
            name="customer_info.last_name"
            component={TextField}
            floatingLabelText="Family Name"
            fullWidth={true}
          />
          <Field
            name="customer_info.email"
            component={TextField}
            floatingLabelText="Email"
            fullWidth={true}
          />
          <Field
            name="customer_info.phone"
            component={TextField}
            floatingLabelText="Phone"
            fullWidth={true}
          />
        </DivCustomerInfoBox>
        <DivCustomerInfoBox1>
          <Field
            name="customer_info.country"
            component={TextField}
            floatingLabelText="Country"
            fullWidth={true}
          />
          <Field
            name="customer_info.province"
            component={TextField}
            floatingLabelText="Province"
            fullWidth={true}
          />
          <Field
            name="customer_info.city"
            component={TextField}
            floatingLabelText="City"
            fullWidth={true}
          />
          <Field
            name="customer_info.zip"
            component={TextField}
            floatingLabelText="Postal / Zip"
          />
          <Field
            name="customer_info.address"
            component={renderMultiTextField}
            label="Address"
          />
        </DivCustomerInfoBox1>
      </DivCustomerInfo>
    </div>
  );
};

export const renderItemsFieldsSmall = (items, index, fields, permissions) => {
  fields.get(index).subtotal =
    fields.get(index).qty * fields.get(index).discountedPrice;
  return (
    <TableRow key={index}>
      <TableRowColumn style={{ height: "100%", whiteSpace: "normal" }}>
        <Field
          floatingLabelText="SKU"
          label="SKU"
          name={`${items}.sku`}
          component={renderTextFieldView}
          placeholder="sku"
        />
        <Field
          floatingLabelText="Quantity"
          label="Quantity"
          name={`${items}.qty`}
          component={renderTextFieldView}
          placeholder="qty"
        />
        <Field
          floatingLabelText="Price"
          label="Price"
          name={`${items}.discountedPrice`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="price"
        />
        <Field
          floatingLabelText="Subtotal"
          label="Subtotal"
          name={`${items}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
      </TableRowColumn>
    </TableRow>
  );
};
export const renderItemsFields = (
  items,
  index,
  fields,
  permissions,
  onChangeItemSKU,
  onChangeItemQuantity
) => {
  fields.get(index).subtotal =
    fields.get(index).qty * fields.get(index).discountedPrice;
  return (
    <TableRow key={index}>
      <TableRowColumn>
        <Field
          label=""
          name={`${items}.sku`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="sku"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${items}.qty`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="qty"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 100, textAlign: "right" }}>
        <Field
          label=""
          name={`${items}.discountedPrice`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="0"
          style={{ width: 100 }}
          inputStyle={{ textAlign: "right", width: 100 }}
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 100, textAlign: "right" }}>
        <Field
          label=""
          name={`${items}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="0"
          style={{ width: 100 }}
          inputStyle={{ textAlign: "right", width: 100 }}
        />
      </TableRowColumn>
    </TableRow>
  );
};
export const renderItemList = ({
  fields,
  permissions,
  onChangeItemSKU,
  onChangeItemQuantity
}) => {
  return (
    <Responsive
      small={
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            {fields.map((items, index, fields) =>
              renderItemsFieldsSmall(
                items,
                index,
                fields,
                permissions,
                onChangeItemSKU,
                onChangeItemQuantity
              )
            )}
          </TableBody>
        </Table>
      }
      medium={
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn tooltip="SKU">Item</TableHeaderColumn>
              <TableHeaderColumn style={{ width: 50 }} tooltip="Quantity">
                Quantity
              </TableHeaderColumn>

              <TableHeaderColumn
                style={{ width: 100, textAlign: "right" }}
                tooltip="Price"
              >
                Price
              </TableHeaderColumn>
              <TableHeaderColumn
                style={{ width: 100, textAlign: "right" }}
                tooltip="Total"
              >
                Total
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {fields.map((items, index, fields) =>
              renderItemsFields(
                items,
                index,
                fields,
                permissions,
                onChangeItemSKU,
                onChangeItemQuantity
              )
            )}
          </TableBody>
        </Table>
      }
    />
  );
};

export const renderItemsFieldsSmallOld = (
  items,
  index,
  fields,
  permissions
) => {
  fields.get(index).subtotal =
    fields.get(index).qty * fields.get(index).discountedPrice;
  return (
    <TableRow key={index}>
      <TableRowColumn style={{ height: "100%", whiteSpace: "normal" }}>
        {/* {permissions==="Admin" && <Field  key={index} floatingLabelText="SKU" name={`${items}.sku`} component={SelectField} onChange={(event,value)=> this.onChangeItemSKU(event, value, index)}  placeholder="item">
              {this.state.dataItems.map((item, indexx) =>{
                return (<MenuItem value={item.sku} key={indexx} primaryText={item.sku} />)
              })}
            </Field>} */}
        {permissions !== "Admin" && (
          <Field
            floatingLabelText="SKU"
            label="SKU"
            name={`${items}.sku`}
            component={renderTextFieldView}
            placeholder="sku"
          />
        )}
        {permissions === "Admin" && (
          <Field
            floatingLabelText="Quantity"
            parse={v => v * 1}
            name={`${items}.qty`}
            component={TextField}
            onChange={(event, value) =>
              this.onChangeItemQuantity(event, value, index)
            }
            placeholder="0"
          />
        )}
        {permissions !== "Admin" && (
          <Field
            floatingLabelText="Quantity"
            label="Quantity"
            name={`${items}.qty`}
            component={renderTextFieldView}
            placeholder="qty"
          />
        )}
        <Field
          floatingLabelText="Available"
          label="Available"
          name={`${items}.available`}
          component={renderTextFieldView}
          placeholder="available"
        />
        <Field
          floatingLabelText="Price"
          label="Price"
          name={`${items}.discountedPrice`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="price"
        />
        <Field
          floatingLabelText="Subtotal"
          label="Subtotal"
          name={`${items}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
        {permissions === "Admin" && (
          <div style={{ textAlign: "right", marginBottom: 10 }}>
            <FlatButton
              primary
              label="Remove"
              onClick={() => fields.remove(index)}
              icon={<ActionDelete />}
            />
          </div>
        )}
      </TableRowColumn>
    </TableRow>
  );
};
export const renderItemsFieldsOld = (
  items,
  index,
  fields,
  permissions,
  onChangeItemSKU,
  onChangeItemQuantity
) => {
  fields.get(index).subtotal =
    fields.get(index).qty * fields.get(index).discountedPrice;
  return (
    <TableRow key={index}>
      <TableRowColumn>
        {/* {permissions==="Admin" && <Field  key={index} label="SKU" name={`${items}.sku`} component={SelectField} onChange={(event,value)=>  onChangeItemSKU(event, value, index)} placeholder="item">
              {this.state.dataItems.map((item, indexx) =>{
                return (<MenuItem value={item.sku} key={indexx} primaryText={item.sku} />)
              })}
            </Field>} */}
        {permissions !== "Admin" && (
          <Field
            label=""
            name={`${items}.sku`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="sku"
          />
        )}
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        {permissions === "Admin" && (
          <Field
            label=""
            parse={v => v * 1}
            name={`${items}.qty`}
            component={TextField}
            onChange={(event, value) =>
              onChangeItemQuantity(event, value, index)
            }
            placeholder="0"
          />
        )}
        {permissions !== "Admin" && (
          <Field
            label=""
            name={`${items}.qty`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="qty"
          />
        )}
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${items}.available`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="0"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${items}.discountedPrice`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="0"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 80 }}>
        <Field
          label=""
          name={`${items}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="0"
        />
      </TableRowColumn>
      <TableRowColumn style={{ textAlign: "right", width: 30 }}>
        {permissions === "Admin" && (
          <FlatButton
            primary
            label=""
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        )}
      </TableRowColumn>
    </TableRow>
  );
};
export const renderItemListOld = ({
  fields,
  permissions,
  onChangeItemSKU,
  onChangeItemQuantity
}) => {
  return (
    <Responsive
      small={
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            {fields.map((items, index, fields) =>
              renderItemsFieldsSmall(
                items,
                index,
                fields,
                permissions,
                onChangeItemSKU,
                onChangeItemQuantity
              )
            )}
          </TableBody>
          <TableFooter adjustForCheckbox={false}>
            <TableRow>
              <TableRowColumn style={{ textAlign: "center" }}>
                {permissions === "Admin" && (
                  <FlatButton
                    primary
                    label="add another item"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                )}
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
      }
      medium={
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn tooltip="Item">Item</TableHeaderColumn>
              <TableHeaderColumn style={{ width: 50 }} tooltip="Quantity">
                Quantity
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 50 }} tooltip="Available">
                Available
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 50 }} tooltip="Price(Rp)">
                Price(Rp)
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 100 }} tooltip="Total">
                Total(Rp)
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: 30 }} />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {fields.map((items, index, fields) =>
              renderItemsFields(
                items,
                index,
                fields,
                permissions,
                onChangeItemSKU,
                onChangeItemQuantity
              )
            )}
          </TableBody>
          <TableFooter adjustForCheckbox={false}>
            <TableRow>
              <TableRowColumn style={{ textAlign: "center" }}>
                {permissions === "Admin" && (
                  <FlatButton
                    primary
                    label="add another item"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                )}
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/orders/edit/EditOrderField.js